import { RequestBaseService } from '../services/http-base/request-base.service';
import { Location } from './location';
import { UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { Input } from '@angular/core';
import { TreeNode } from 'primeng/api';

export interface FormInputConfig {
  type: AllInputTypes;
  name: string;
  addedBforeItems?: any;
  groupList?: FormInputConfig[];
  defaultValue?: any;
  globalClass?: string;
  inputClass?: string;
  hint?: string;
  widthClass?: string;
  placeholder?: string;
  label?: string;
  labelIcon?: string;
  fixedHint?: boolean;
  enabilLabelClick?: boolean;
  stopPaste?: boolean;
  isDisable?: boolean;
  isDateTimePickerZoneUtc?: boolean;
  enableAddNewBtn?: boolean;
  hasAlert?: boolean;
  alertClass?: string;
  alertMessage?: string;
  phoneNumberErrorPatternMessage?: string;
  hide?: boolean;
  mobileTypeCode?: boolean;
  mobileNumberCode?: string;
  validation?: FormValidation[];
  fileConfig?: {
    multiple?: boolean;
    allowedExtension?: string[];
    keepFile?: boolean;
    keyName?: string;
    shape?: string;
    inputHint?: string;
    previewImg?: boolean;
    cacheFiles?: boolean;
    resize?: boolean;
    dimensions?: { w: number; h: number };
  };
  savedValue?: any;
  listValues?: ListValues[];
  listTreeValues?: TreeNode[];
  minValue?: any;
  maxValue?: any;
  rows?: any;
  columns?: any;
  change?: (
    value: any,
    formConfig: FormInputConfig[],
    formGroup?: UntypedFormGroup,
    allFormConfig?: FormInputConfig[],
    updateFieldConfig?: (key: string, changes: Partial<FormInputConfig>) => void
  ) => void;
  changeEffect?: ChangeEffection[];
  isOptionalButton?: boolean;
  optionalButtonName?: string;
  optionalButtonClass?: string;
  optionalButtonClick?(formGroup?: UntypedFormGroup): void;
  isSearch?: boolean;
  labelClass?: string;
  inlineWidthClass?: string;
  dynamicLoad?: {
    url: string;
    type: 'get' | 'post';
    arrayAttributeName: string;
    labelKey: string;
    valueKey: string;
    params?: any;
    defulatSelect?: any;
    subData?: ListValues[];
    loadService?: RequestBaseService;
    dataPrepare?: (data: any[]) => ListValues[];
    responseDataPrepare?: (data: any[]) => ListValues[];
  };
  listLoad?: {
    url: string;
    type: 'get' | 'post';
    arrayAttributeName: string;
    labelKey: string;
    valueKey: string;
    loadService: RequestBaseService;
    loadOnChange?: string;
    showLoader?: boolean;
    params?: any;
    defulatSelect?: any;
    defualtLoadValue?: any;
    subData?: ListValues[];
    prepareRequest?: (loadService: RequestBaseService, value: any) => void;
    responseDataPrepare?: (data: any[]) => ListValues[];
    getPreparedData?: (data: ListValues[]) => void;
  };
  isRequired?: boolean;
  ArrayConfigration?: FormArrayConfig;
  clearable?: boolean;
  hasSelectAll?: boolean;
  locations?: Location[];
  enableQuickLatLongSearch?: boolean;
  hasTime?: boolean;
  isTimeOnly?: boolean;
  monthDateLimit?: number;
  timePickerIncrement?: number;
  autoApply?: boolean;
  openInModal?: boolean;
  hideDaterangeBtnClass?: boolean;
  chipsOptions?: {
    validations?: any[];
    errorMessages?: any;
  };
  [key: string]: any;
  loadOnScroll?: boolean;
  customFieldTemplate?: customFieldTemplate;
  isUnique?: boolean;
  suffix?: string;
  mode?: string;
  minFractionDigits?: string;
  maxFractionDigits?: string;
  useGrouping?: boolean;
}

export interface FormArrayConfig {
  ledding: {
    label: string;
    lableClass?: string;
    btnText?: string;
    btnClass?: string;
    btnIcon?: string;
    leddingClass?: string;
  };
  itemClass?: string;
  maximumRowsNum?: number;
  hasAlert?: boolean;
  alertMessage?: string;
  alertClass?: string;
  fields?: FormInputConfig[];
  list: FormInputConfig[][];
  defualtValue: any[];
  defualtItemValue: any;
  dynamicItemValue?: any;
  fieldsUnique?: { [fieldName: string]: boolean };
}
export interface FormValidation {
  function: ValidatorFn;
  errorMessage: string;
  errorName?: string;
}
export interface ChangeEffection {
  field: string;
  showWhen: any;
}
export interface ListValues {
  label: string;
  value: any;
  picture?: string;
  styleClass?: string;
  [t: string]: any;
}
export enum AllInputTypes {
  Text = 'text',
  Number = 'number',
  MobileNumber = 'mobileNumber',
  Email = 'email',
  Password = 'password',
  Select = 'select',
  MultiSelect = 'multiSelect',
  MultiSelectTree = 'multiSelectTree',
  CheckBox = 'checkbox',
  RadioBox = 'radio',
  ToggleButton = 'toggleButton',
  SlideValue = 'range',
  ChooseFile = 'file',
  DropFile = 'dropFile',
  Date = 'date',
  Year_month = 'year_month',
  DateRange = 'dateRange',
  Textarea = 'textarea',
  HtmlEditor = 'htmlEditor',
  Captcha = 'captcha',
  ViewText = 'viewText',
  Array = 'array',
  Group = 'group',
  Map = 'map',
  Chips = 'chips',
  Mask = 'mask',
  Auto_complete = 'autoComplete',
  ReadOnly = 'readOnly',
  Custom_Year_month = 'custom_year_month',
  Range_Year_month = 'range_year_month',
  Select_scroll = 'select-scroll',
  DateTime = 'dateTime',
  Auto_complete_text = 'auto_complete_text',
  Time = 'time'
}
export interface customFieldTemplate {
  disableClick: boolean;
  template(formGroup?: UntypedFormGroup): string;
  handleClick?(formItem?: FormInputConfig, formGroup?: UntypedFormGroup): void;
}

// Define the ListTreeValues interface
export interface ListTreeValues {
  item?: any;
  key: string; // Unique identifier for the node
  label: string; // Display label for the node
  group?: string; // Group name (optional)
  children?: ListTreeValues[]; // Nested children nodes (optional)
  partialSelected?: boolean; // Indicates partial selection (optional)
}
